// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".listContain3 .tablelistBody .el-table{height:31.146vw!important}.listContain3 .tablelistBody .el-table .el-table__body-wrapper{height:31.458vw!important}", ""]);
// Exports
module.exports = exports;
